import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from './Home.vue';
import Colors from './demo/Colors.vue';
import Type from './demo/Type.vue';
import ButtonsPage from './demo/pages/ButtonsPage.vue';
import FormElementsPage from './demo/pages/FormElementsPage.vue';
import CardDemo from './demo/pages/CardDemo.vue';
import NavsPage from './demo/pages/NavsPage.vue';
import DatatableDemo from './demo/pages/DatatableDemo.vue';
import TreeselectDemo from './demo/pages/TreeselectDemo.vue';
import ReviewCardDemo from './demo/pages/ReviewCardDemo.vue';
import FiltersDemo from './demo/pages/FiltersDemo.vue';
import GraphDemo from './demo/pages/GraphDemo.vue';

import RPDashboardLayout from './components/Layouts/SingleUse/RPDashboardLayout.vue';

import LayoutDemo from './demo/pages/LayoutDemo.vue';
import ModalDemo from './demo/pages/ModalDemo.vue';
import RPSettingsLayout from './components/Layouts/Common/RPSettingsLayout.vue';
import RPDatatableLayout from './components/Layouts/Common/RPDatatableLayout.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/colors',
        name: 'Colors',
        component: Colors,
    },
    {
        path: '/type',
        name: 'Type',
        component: Type,
    },
    {
        path: '/buttons',
        name: 'Basic',
        component: ButtonsPage,
    },
    {
        path: '/form',
        name: 'FormElements',
        component: FormElementsPage,
    },
    {
        path: '/navs',
        name: 'NavsPage',
        component: NavsPage,
    },
    {
        path: '/cards',
        name: 'CardsDemo',
        component: CardDemo,
    },
    {
        path: '/tables',
        name: 'DatatableDemo',
        component: DatatableDemo,
    },
    {
        path: '/modal',
        name: 'ModalDemo',
        component: ModalDemo,
    },
    {
        path: '/treeselect',
        name: 'TreeselectDemo',
        component: TreeselectDemo,
    },
    {
        path: '/respond',
        name: 'ReviewCardDemo',
        component: ReviewCardDemo,
    },
    {
        path: '/filters',
        name: 'FiltersDemo',
        component: FiltersDemo
    },
    {
        path: '/graphs',
        name: 'GraphDemo',
        component: GraphDemo
    },
    {
        path: '/layouts',
        component: LayoutDemo,
        children: [
            {
                path: '/dashboard',
                name: 'DashboardLayout',
                component: RPDashboardLayout,
            },
            {
                path: '/settings',
                name: 'SettingsLayout',
                component: RPSettingsLayout,
            },
            {
                path: '/datatable',
                name: 'DatatableLayout',
                component: RPDatatableLayout,
            },
        ],
    },
];

const router = new VueRouter({
    mode: 'history',
    routes,
});

export default router;
